import { PayloadAction } from '@reduxjs/toolkit'
import { getProductOperations } from '@repo/accounts-services'
import { OperationFiltersState, ProductOperationParams } from '@repo/accounts-types'
import { defineSagaForService, DownloadServiceConfiguration } from '@repo/core'
import { put } from 'redux-saga/effects'
import {
  accountsOperationsFiltersActions,
  productOperationsMasterListActions,
  productOperationsMasterListDownloadActions,
} from '../../../../slices'

export const productOperationsDownloadConfig: Record<string, DownloadServiceConfiguration> = {
  [productOperationsMasterListDownloadActions.downloadRequest.type]: {
    apiClientDomain: 'accounts',
    service: getProductOperations as DownloadServiceConfiguration['service'],
    actionTypeRequest: productOperationsMasterListDownloadActions.downloadRequest.type,
    actionTypeResponse: productOperationsMasterListDownloadActions.downloadResponse.type,
  },
}

export const serviceConfig = defineSagaForService({
  [productOperationsMasterListActions.getRequest.type]: {
    apiClientDomain: 'accounts',
    service: getProductOperations,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: productOperationsMasterListActions.getResponse.type,
    actionTypeRequest: productOperationsMasterListActions.getRequest.type,
  },
  [productOperationsMasterListActions.refreshRequest.type]: {
    apiClientDomain: 'accounts',
    service: getProductOperations,
    getError: (error) => error.response?.data || error.message,
    actionTypeResponse: productOperationsMasterListActions.refreshResponse.type,
    actionTypeRequest: productOperationsMasterListActions.refreshRequest.type,
  },
})

export function* loadProductOperationsByFilters({
  payload,
}: PayloadAction<ProductOperationParams>) {
  const { accountId, isinId, ...filters } = payload
  yield put(accountsOperationsFiltersActions.setFilter(filters as OperationFiltersState))
  yield put(productOperationsMasterListActions.getRequest({ accountId, isinId, ...filters }))
}
